import cn from 'classnames';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { baseCellClassname, stickyShadowStyles } from '@lp/features/Scheduler/constants';
import { useSOnCallDayTotalsMap } from '@lp/features/Scheduler/SchedulerSurgeons/components/SSchedulerTable/hooks';
import { SResource, SResourcesWithShifts } from '@/api/apis/resources/schedule';

type SOnCallTotalsSubTableProps = {
  regionId: string;
  dayCols: SchedulerDayColumn[];
  userList: SResource[];
  shiftsData: SResourcesWithShifts;
};

export const SOnCallTotalsSubTable = ({ regionId, dayCols, userList, shiftsData }: SOnCallTotalsSubTableProps) => {
  const daysTotalsMap = useSOnCallDayTotalsMap(dayCols, userList, shiftsData, regionId);

  return (
    <tr key="totalOnCallRow">
      <td className={cn('h-9 sticky left-0 px-3 bg-white border-none z-2', stickyShadowStyles)}>
        <span className="text-m-m text-base-5">Total On Call</span>
      </td>
      {dayCols.map((column) => (
        <td
          key={column.key}
          className={cn('text-m-m text-base-5 text-end', baseCellClassname, { 'bg-base-70!': column.isSelectedDay })}
        >
          <span>{daysTotalsMap.get(column.key) ?? 0}</span>
        </td>
      ))}
    </tr>
  );
};
